import { AwmFundResponse } from '@repo/accounts-types'
import { ApiResponse, DownloadState, GenericOperationState } from '@repo/core'
import { RootState } from '../../../../store/types'

export const awmFundsDataSelectorConfig = {
  awmFundsDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<AwmFundResponse> | null> {
      return state.accounts.detail.read.fund.awmFunds
    },
  },
  awmFundsDownloadSelector: {
    getRootPath: (state: RootState): DownloadState =>
      state.accounts.detail.read.fund.awmFundsDownload,
  },
}
